// Implements: F-UIX-007
/**
 * The small (i) next to a field: its long explanation as a tooltip, so the form keeps one short line
 * per field. A real button (Tab reaches it, the tooltip shows on focus at once and on hover after the
 * delay) named "Más información: <campo>"; it carries the explanation as its description, never as
 * its only name.
 */

import type { ReactElement } from "react";

import { useTranslation } from "../../i18n";
import { Icon } from "../atoms/Icon";
import styles from "./InfoTip.module.css";
import { Tooltip } from "./Tooltip";

export interface InfoTipProps {
  /** The field it explains, as the person reads it. */
  readonly subject: string;
  /** The explanation (from `t()`). */
  readonly content: string;
  /** Hover delay; injectable for tests. */
  readonly delayMs?: number | undefined;
}

export function InfoTip({ subject, content, delayMs }: InfoTipProps): ReactElement {
  const { t } = useTranslation();
  return (
    <Tooltip content={content} delayMs={delayMs}>
      <button type="button" className={styles.button} aria-label={t("common.moreInfo", { subject })}>
        <Icon name="info" size="sm" />
      </button>
    </Tooltip>
  );
}
